<template lang="pug">
nav.container.mx-auto.p-4
  .flex.flex-col.sm_flex-row.justify-center
    div(v-for='(page,index) of allPages').text-md_sm_text-2xl.text-center
      .flex.items-center.h-8
        div(v-if="index !== 0").hidden.sm_block.mx-4.border-r.h-full.border-acn-green
        router-link(  exact-active-class='underline text-acn-green-dark' :to="{name:page.typeHandle, params:{ slug:page.slug }}").mx-auto.hover_underline {{page.title}}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PageMenu',
  computed: {
    ...mapGetters(['allPages']),
  },
}
</script>
